var map = {
	"./a-guide-on-how-to-navigate-u-of-t-research-and-employment-landscape.json": 2876,
	"./a-guide-to-navigating-long-distance-friendships.json": 2971,
	"./a-guide-to-teams-to-watch-and-events-to-attend-in-toronto.json": 3117,
	"./an-overview-of-some-of-u-of-t-st-georges-libraries.json": 2303,
	"./cheap-tasty-and-quality-food-around-campus.json": 612,
	"./cultural-hotspots-in-toronto.json": 668,
	"./getting-involved-with-the-varsity.json": 5063,
	"./housing-tips-for-finding-a-place-in-toronto.json": 807,
	"./how-physical-activity-can-improve-your-academic-performance.json": 6178,
	"./how-to-manage-your-courseload.json": 2823,
	"./i-make-time-to-go-outside-you-should-too.json": 2711,
	"./important-news-stories.json": 8033,
	"./important-people-at-u-of-t.json": 8794,
	"./mental-physical-and-academic-resources-for-every-u-of-t-student.json": 7543,
	"./networking-in-your-undergrad.json": 8826,
	"./places-of-worship-and-religious-and-spiritual-associations-at-u-of-t.json": 9866,
	"./sexual-health-care-at-u-of-t.json": 9375,
	"./socializing-from-scratch.json": 2835,
	"./the-best-toronto-date-spots-for-university-students.json": 7014,
	"./ways-to-get-involved-creatively-at-u-of-t.json": 984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4276;